import {registerStyle, styleRule, StyleSheet, UI} from "../../../../stem-core/src/ui/UI";
import {FacebookIcon, GoogleIcon, LinkedInIcon, TwitterIcon} from "../../../SVGElements";
import {FacebookButton, GoogleButton, LinkedInButton, TwitterButton} from "../../../ui/Button";
import {Messages} from "../../../Messages";
import {NOOP_FUNCTION} from "../../../../stem-core/src/base/Utils";
import {SOCIAL_APPS} from "../../../../blink-sdk/Constants";


const socialAppDescriptors = {
    [SOCIAL_APPS.Facebook]: {
        clientName: "facebook",
        icon: FacebookIcon,
        className: FacebookButton,
    },
    [SOCIAL_APPS.Google]: {
        clientName: "google",
        icon: GoogleIcon,
        className: GoogleButton,
    },
    [SOCIAL_APPS.Twitter]: {
        clientName: "twitter",
        icon: TwitterIcon,
        className: TwitterButton,
    },
    [SOCIAL_APPS.LinkedIn]: {
        clientName: "linkedin",
        icon: LinkedInIcon,
        className: LinkedInButton,
    },
};

export class SocialLoginButtosStyle extends StyleSheet {
    @styleRule
    buttons = {
        display: "flex",
        justifyContent: "space-between",
        maxWidth: 282,
        margin: "auto",
    };

    @styleRule
    label = {
        fontSize: 13,
        color: this.themeProps.LABEL,
        marginBottom: 18,
    };
}

@registerStyle(SocialLoginButtosStyle)
export class SocialLoginButtons extends UI.Element {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            label: Messages.continueWithSocial,
            onButtonClick: NOOP_FUNCTION,
            onLoginCallback: NOOP_FUNCTION,
            onLoginErrorCallback: NOOP_FUNCTION,
            socialApps: Object.keys(socialAppDescriptors),
        };
    }

    getSocialApps() {
        return this.options.socialApps.filter(socialApp => socialApp !== SOCIAL_APPS.CDS);
    }

    render() {
        const {styleSheet} = this;
        const {onLoginCallback, onLoginErrorCallback, label} = this.options;

        if (!this.getSocialApps().length) {
            return null;
        }

        return [
            label ? <div className={styleSheet.label}>{label}</div> : null,
            <div className={styleSheet.buttons}>{this.getSocialButtons(onLoginCallback, onLoginErrorCallback)}</div>,
        ];
    }

    getSocialButtons(loginSuccessCallback, loginErrorCallback) {
        return this.getSocialApps().map(appName => {
            const ButtonClassName = socialAppDescriptors[appName].className;
            const clientName = socialAppDescriptors[appName].clientName;
            return (
                <ButtonClassName
                    testId={clientName + "Button"}
                    clientName={clientName}
                    onClick={() => this.options.onButtonClick(socialAppDescriptors[appName])}
                    onLoginCallback={() => loginSuccessCallback()}
                    onLoginErrorCallback={error => loginErrorCallback(error)}
                />
            );
        });
    }
}
